export default __webpack_public_path__ + "images/dd7076498b99577205b5667490abcd97.png";